/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

// @ts-nocheck
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext, useEffect, useMemo, useState, useRef } from 'react';
import { Form, Formik } from "formik";
import * as yup from 'yup';
import { useHistory, useLocation } from 'react-router-dom';
import _ from 'lodash';

import Layout from 'components/Layout';
import BrokingSummary from 'components/BrokingSummary';
import { ButtonContainer, ButtonContent } from 'components/Button';
import { Col, Row } from 'components/Grid';
import { InputField } from "components/Form";
import DialogComponent from 'components/Dialog';
import { ModalEditConfirmation } from 'components';

import Colors from 'constants/Colors';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext } from 'store/context';
import { LoaderContext } from '@fitinsur/contexts'
import {
  FormContainer,
  FormSectionGlobal as FormSection,
  DragZoneUpload,
  HasPermission,
  Button
} from '@fitinsur/components';

import ListDetail from './listDetail';
import ListHeader from './listHeader';

import { useGetDealDocuments } from 'services/DocumentsService';
import { useGetOperation } from 'services/OperationService';
import { useSignatureDocumentSompo } from 'services/IssueService';
import { useSendDocuments } from '@fitinsur/services/DocumentsService';
import { useGetQuestionnaireAnswer, useSaveQuestionnaireAnswer } from '@fitinsur/services/QuestionnaireAnswerService';
import { useGetDocuments } from '@fitinsur/services/DocumentsService';
import { events } from 'containers/creditAnalysis/edit/sectionHandlers/general/events/index';

import { Text, Content, ListContent, Container, RowSearch, FieldGrid, FolderSelect } from './styles';

export default function DocumentManagement({ permissions, ...props }) {
  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const getQuestionnaire = useRef(false);

  const columns = [
    {
      title: "Nome",
      value: "nmParty",
      col: 3,
      style: ''
    },
    {
      title: "Versão",
      value: "nmInterest",
      col: 2,
      style: ''
    },
    {
      title: "Tipo",
      value: "documentType",
      col: 2,
      style: ''
    },
    {
      title: "Feito Por",
      value: "uploadBy",
      col: 2,
      style: ''
    },
    {
      title: "Data",
      value: "date",
      col: 2,
      style: ''
    },

    {
      title: "Ação",
      value: "action",
      col: 1,
      style: 'pr-0'
    },

  ];

  const initialValues = {
    search: ""
  };

  const formik = useRef(null);
  const authContext = useContext(GlobalAuthContext);
  const isClient = useMemo(() => authContext.enumProfile === 1, []);
  const [shouldRenderOperationFilter, setShouldRenderOperationFilter] = useState(false);
  const [operationsList, setOperationsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingFiles, setLoadingFiles] = useState(false);

  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const [documents, setDocuments] = useState([]);
  const [documentsOperation, setDocumentsOperation] = useState([]);
  const [signedDocuments, setSignedDocuments] = useState(0);
  const [dealDocuments, setDealDocuments] = useState(0);
  const [supportDocuments, setSupportDocuments] = useState(0);
  const [internalDocuments, setInternalDocuments] = useState(0);
  const [paymentDocuments, setPaymentDocuments] = useState(0);
  const [creditAnalysis, setCreditAnalysis] = useState(0);
  const [renderScreen, setRenderScreen] = useState("");
  const [showAttachments, setShowAttachments] = useState(false);
  const [attachemnts, setAttachments] = useState([]);
  const [selectedAllDocsCheckBox, setSelectedAllDocsCheckBox] = useState(false);
  const [selectedFolds, setSelectedFolds] = useState([]);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [operation, setOperation] = useState();
  const [documentCcg, setDocumentCcg] = useState(null);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [questionAttachment, setquestionAttachment] = useState({});
  const [documentsExpired, setDocumentsExpired] = useState([]);
  const [canAuthPolicyPack, setCanAuthPolicyPack] = useState(false);
  const location = useLocation();
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });
  const [sortBy, setSortBy] = useState(
    {
      key: null,
      direction: null,
    }
  );
  const [modalCcgConfirmation, setModalCcgConfirmation] = useState({
    show: false,
    text: null,
    onConfirm: () => { },
    onCancel: () => { }
  });

  const {
    data: useGetDealDocumentsData,
    loading: useGetDealDocumentsLoading,
    error: useGetDealDocumentsError,
    status: useGetDealDocumentsStatus,
    request: useGetDealDocumentsRequest,
  } = useGetDealDocuments(props.match.params?.idOperation);

  const {
    data: useGetOperationData,
    loading: useGetOperationLoading,
    error: useGetOperationError,
    status: useGetOperationStatus,
    request: useGetOperationRequest
  } = useGetOperation(props.match.params?.idOperation);

  const {
    loading: useSignatureDocumentSompoRequestLoading,
    request: useSignatureDocumentSompoRequest
  } = useSignatureDocumentSompo();

  const {
    data: useSendDocumentsData,
    loading: useSendDocumentsLoading,
    error: useSendDocumentsError,
    status: useSendDocumentsStatus,
    request: useSendDocumentsRequest
  } = useSendDocuments(props.match.params?.idOperation);

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation || operation.idOperation);

  const {
    data: useGetDocumentsData,
    loading: useGetDocumentsLoading,
    error: useGetDocumentsError,
    status: useGetDocumentsStatus,
    request: useGetDocumentsRequest,
  } = useGetDocuments(props.match.params.idOperation || operation.idOperation);

  const {
    data: useSaveQuestionnaireAnswerData,
    loading: useSaveQuestionnaireAnswerLoading,
    error: useSaveQuestionnaireAnswerError,
    status: useSaveQuestionnaireAnswerStatus,
    request: useSaveQuestionnaireAnswerRequest,
  } = useSaveQuestionnaireAnswer(props.match.params.idOperation);

  useEffect(() => {
    const isEmpty = _.isEmpty(permissions);

    updateIsLoadingStatus(
      isEmpty ||
      loadingFiles ||
      loading ||
      useGetDealDocumentsLoading ||
      useGetOperationLoading ||
      useSignatureDocumentSompoRequestLoading ||
      useSendDocumentsLoading ||
      useGetQuestionnairesAnswersLoading ||
      useSaveQuestionnaireAnswerLoading ||
      useGetDocumentsLoading
    );
  }, [
    loading,
    useGetDealDocumentsLoading,
    useGetOperationLoading,
    useSignatureDocumentSompoRequestLoading,
    useSendDocumentsLoading,
    useGetQuestionnairesAnswersLoading,
    useSaveQuestionnaireAnswerLoading,
    useGetDocumentsLoading,
    permissions
  ]);

  useEffect(() => {
    if (getQuestionnaire.current) return;
    if (_.isEmpty(permissions)) return;
    getQuestionnaire.current = true

    useGetOperationRequest();
  }, [permissions]);

  useEffect(() => {

    if (operation && location.search) {
      handleSetFilterFromParams()
      let obj = {};
      for (const [key, value] of (new URLSearchParams(location.search)).entries()) {
        obj[key] = value;
      }
      getFiles(obj)
    } else if (operation) {
      const filterQueryString = { search: '' };
      useGetDocumentsRequest();
      getFiles(filterQueryString);
    }

  }, [operation]);

  useEffect(() => {
    if (!useGetOperationStatus) return;
    if (useGetOperationStatus === 200) {
      if (useGetOperationData.statusCode === 200) {
        setOperation(useGetOperationData.value);
        useGetQuestionnairesAnswersRequest(null, { idDomainStatus: useGetOperationData.value.idDomainStatus })
      }
    }
  }, [useGetOperationStatus, permissions])

  useEffect(() => {
    if (selectedAllDocsCheckBox) {
      if (documents?.dealDocuments?.length) {
        setSelectedDocs(
          [
            ...documents.signedDocuments,
            ...documents.dealDocuments,
            ...documents.supportDocuments,
            ...documents.internalDocuments,
            ...documents.creditAnalysis,
            ...documents.paymentDocuments
          ])
      }
    } else {
      setSelectedDocs([]);
    }
  }, [selectedAllDocsCheckBox])

  useEffect(() => {
    if (useSendDocumentsStatus === 200) {
      mc.success('Email enviado para o corretor com sucesso.');
    }
  }, [useSendDocumentsStatus])

  useEffect(() => {
    if (useGetDocumentsStatus === 200) {
      const { value: dataDocuments } = useGetDocumentsData;
      setDocumentsOperation(dataDocuments);
    }
  }, [useGetDocumentsStatus])

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200 && useGetQuestionnairesAnswersData) {
      handleQuestionnaire(useGetQuestionnairesAnswersData?.value);
    }
  }, [useGetQuestionnairesAnswersStatus, useGetQuestionnairesAnswersData])

  useEffect(() => {
    const prevCcgDocuments = documents?.signedDocuments?.filter(doc => doc.idDocument !== documentCcg && (doc.idDomain === 689 || doc.rootDocumentIdDomain === 689));
    if (documentCcg && prevCcgDocuments.length > 0) {
      for (let doc of prevCcgDocuments) {
        updateIsLoadingStatus(true);
        fitinsur.setAuthToken(authContext.token);
        fitinsur.requestWordingDelAttach(doc.idOperation, doc.idDocument)
          .then(data => data.json())
          .then(resp => {
            updateIsLoadingStatus(false);
            if (resp.ret_code !== 200) {
              mc.error(resp.ret_msg_details);
              return;
            }
          }).catch(err => {
            updateIsLoadingStatus(false);
            mc.error("Um erro ocorreu ao remover o documento: " + doc.idDocument + err);
            console.log(err);
          });
      };
    }
  }, [documentCcg])


  useEffect(() => {
    if (useSaveQuestionnaireAnswerError) {
      mc.error("Ocorreu um erro ao salvar alterações, tente novamente.");
      setModalCcgConfirmation({ ...modalCcgConfirmation, show: true });
    }
  }, [useSaveQuestionnaireAnswerError])


  const handleSignaturePolicyPack = async () => {
    const policyPack = documents.dealDocuments.find(doc => doc.idDomain === 362);
    if (policyPack) {
      let responseSuccess = false;
      let serviceActive = true;
      let requestAttempts = 0;


      async function getSignatureDocumentSompoRequest() {
        requestAttempts++;

        await useSignatureDocumentSompoRequest({
          idDocument: policyPack?.idDocument
        }).then(res => {
          console.log('res', res)
          if (res.status === 200) {
            responseSuccess = true;
            serviceActive = true
          }
        }).catch(err => {
          const { data: signatureResponse } = err.response;

          if (signatureResponse.ret_code === 423 && !signatureResponse?.ret_value?.serviceActive) {
            serviceActive = false;
            mc.error('O serviço de assinatura de documentos não está ativo neste ambiente.');
          }
        });

        if (!serviceActive) {
          return;
        } else if (responseSuccess) {
          mc.success('Apólice autenticada com sucesso.');
          window.location.reload();
        } else if (!responseSuccess && requestAttempts < 3) {
          await getSignatureDocumentSompoRequest();
        } else {
          mc.error('Não foi possível autenticar a apólice, tente novamente.');
        }
      }

      await getSignatureDocumentSompoRequest();
    }
  }

  const getFiles = async (filterQueryString = '', sortBy, callback) => {
    setLoading(true);
    let idQuestionAttachments = operation && operation.idDomain == 686 ? 1706 : 694;
    await useGetDealDocumentsRequest(null, { ...filterQueryString, idQuestion: idQuestionAttachments, idOperation: props.match.params.idOperation }, {}).then(({ data }) => {
      setLoading(false);

      console.log('dataxxxx', loading, data)
      if (data.ret_code != 200) {
        mc.error(data.ret_msg_details);
        // history.goBack()
        return;
      }

      setCanAuthPolicyPack(!!(
        !data.ret_value?.dealDocuments?.find(doc => doc.idDomain === 736) &&
        data.ret_value?.dealDocuments?.find(doc => doc.idDomain === 362)
      ));

      data.ret_value.dealDocuments = data.ret_value.dealDocuments.filter(
        doc => ![25, 373, 736].includes(doc.idDomain)
      );

      data.ret_value.paymentDocuments = data.ret_value.paymentDocuments.filter(
        doc => ![264, 370].includes(doc.idDomain)
      );

      setDocuments(data.ret_value);
      setDealDocuments(data.ret_value?.dealDocuments?.length);
      setSignedDocuments(data.ret_value?.signedDocuments?.length);
      setInternalDocuments(data.ret_value?.internalDocuments?.length);
      setSupportDocuments(data.ret_value?.supportDocuments?.length);
      setCreditAnalysis(data.ret_value?.creditAnalysis?.length);
      setPaymentDocuments(data.ret_value?.paymentDocuments?.length);

      if (callback) callback();
    }).catch(err => {
      setLoading(false);
      console.log(err);
    })
  }

  const handleQuestionnaire = (data) => {
    console.log("Handlequestionnaire");

    let questionnaireData = JSON.parse(JSON.stringify([
      ...data.persons,
      ...data.operations,
      ...data.payments,
      ...data.risks
    ]));

    const qstAtthment = questionnaireData.find(qst => qst.idQuestion === (operation && operation.idDomain == 686 ? 1706 : 694));
    setquestionAttachment(qstAtthment);

    setTimeout(() => {
      let questionnaireFilter = questionnaireData
        .filter(qst => [1727, 2016].includes(qst.idQuestion))
        .map(qst => {
          qst.visibleQuestion = true;
          qst.behaviorObject.sectionName = "ATTACHMENT_CCG";
          qst.behaviorObject.desktopWidth = 100;
          qst.behaviorObject.isReadOnly = false;
          qst.behaviorObject.isRequired = true;

          if (qst.idQuestion === 2016) {
            qst.behaviorObject.isRequired = false;
            qst.answer = '';
          }

          return qst;
        })
        .sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

      setQuestionnaire(questionnaireFilter.map(qst => { return { ...qst, visibleQuestion: true } }));

    }, 300);
  }

  const handleSelectFolders = (folderName) => {
    const isCurrentlySelected = selectedFolds.includes(folderName);
    let newSelectedDocs = [...selectedDocs];

    if (isCurrentlySelected) {
      setSelectedFolds(selectedFolds.filter(f => f !== folderName));

      documents[folderName].forEach(doc => {
        newSelectedDocs = newSelectedDocs.filter(d => d !== doc.idDocument);
      });

    } else {
      setSelectedFolds([...selectedFolds, folderName]);

      documents[folderName].forEach(doc => {
        if (!newSelectedDocs.includes(doc.idDocument)) newSelectedDocs.push(doc.idDocument);
      });
    }

    setSelectedDocs(newSelectedDocs);
  };

  const handleSelectDocument = (docId, folderName) => {
    const isCurrentlySelected = selectedDocs.includes(docId);
    let newSelectedDocs = [...selectedDocs];

    if (isCurrentlySelected) {
      newSelectedDocs = newSelectedDocs.filter(id => id !== docId);
    } else {
      newSelectedDocs.push(docId);
    }

    setSelectedDocs(newSelectedDocs);

    const folderDocsIds = documents[folderName].map(doc => doc.idDocument);
    const allSelected = folderDocsIds.every(id => newSelectedDocs.includes(id));

    if (allSelected) {
      if (!selectedFolds.includes(folderName)) setSelectedFolds([...selectedFolds, folderName]);
    } else {
      setSelectedFolds(selectedFolds.filter(folder => folder !== folderName));
    }
  };

  const showFilesExpired = (idDomain) => {
    updateIsLoadingStatus(true);
    fitinsur.setAuthToken(authContext.token);

    fitinsur.requestGetDealDocuments(props.match.params.idOperation, `?expired=true&idDomain=${idDomain}`)
      .then(response => response.json()).then(data => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack()
          return;
        }
        setDocumentsExpired(data.ret_value);
        setDialog(prev => ({ ...prev, visible: true }))
        updateIsLoadingStatus(false);
      })
  }

  function handleSortList(key) {
    let direction = 'asc';
    if (sortBy.key === key && sortBy.direction === 'asc') {
      direction = 'desc';
    };

    // setFilter({ key: key, direction: direction });

    // console.log("Lista Ordenada-> ", sortList);
    // console.log("Ordem key-> ", filter.direction);
    const sort = { key: key, direction: direction }
    setSortBy(sort);
    getFiles(location.search, sort)

  }

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleBack() {
    history.goBack();
  };

  const fieldRenderOptions = function (options = [], idDomainStatusFilter) {
    if (options.length) {
      let optionsList = options.map(option => {
        let behavior = {};

        try {
          behavior = JSON.parse(option.ANSWER_BEHAVIOR) || {};
        } catch (e) {
          console.error('fieldRenderOptions - Error in parse Behavior')
        }

        if (idDomainStatusFilter) {
          if (
            !Array.isArray(behavior?.idDomainStatusFilter) &&
            behavior?.idDomainStatusFilter !== idDomainStatusFilter
          ) {
            return null;
          } else if (
            Array.isArray(behavior?.idDomainStatusFilter) &&
            !behavior?.idDomainStatusFilter.includes(idDomainStatusFilter)
          ) {
            return null;
          }
        }
        return {
          label: option.ANSWER_OPTION_DESCRIPTION,
          value: {
            idAnswerOption: option.ID_ANSWER_OPTION,
            dsAnswerOption: option.ANSWER_OPTION_DESCRIPTION,
            behavior,
          }
        }
      });

      optionsList = optionsList.filter(Boolean)

      if (operation?.idDomain == 686) {
        const ccgDocument = documentsOperation?.find(doc => doc.idDomain === 689);
        const signatureEnvelope = documentsOperation?.find(doc => doc.idDomain === 366);

        if (!permissions.NBI_REQUEST_APPROVE_REJECT || signatureEnvelope?.idDomainStatus !== 454 || ((![422, 423, 424].includes(ccgDocument?.idDomainStatus)) && (signatureEnvelope?.idDomainStatus === 454))) {
          optionsList = optionsList.filter(opt => opt.value.idAnswerOption !== 7687);
        }

        if ([422, 423, 424].includes(ccgDocument?.idDomainStatus) && questionAttachment) {
          let questionAttachmentAux = questionAttachment;

          questionAttachmentAux.answerOption = questionAttachmentAux.answerOptions.map(v => {
            if (v.idAnswerOption === 7687) {
              v.behaviorObject.resultIdDomainStatusDocument = ccgDocument?.idDomainStatus;
            }

            return v
          });

          setquestionAttachment(questionAttachmentAux)
        }
      }

      return optionsList;
    }

    return [];
  }

  function renderDocuments(title, nameArray, hasUpload, hasDelete, history = false, expired = false) {
    const documentList = expired ? documentsExpired : documents
    return (
      <>
        <>
          {title == "VERSÕES ANTERIORES" ? <div style={{ marginTop: "-30px", marginBottom: "30px" }}><Text>{title}</Text></div> : null}
          <Row style={{ marginBottom: '15px', width: '100%' }}>
            {columns ? columns.map((column, index) =>
              <Col sm={column.col} key={index} className={'d-none d-md-block pl-0 ' + column.style}>
                <Text /* onClick={() => handleSortList(column.value)} */>
                  {column.title}
                </Text>
                {/* {sortBy.key === column.value ? <>
                  {column.title == 'Action' ? null : sortBy.key === column.value && sortBy.direction === "asc" ?
                    <Icon name={"arrowup"} /> : <Icon name={"arrowdown"} />} </> : <></>} */}
              </Col>) : ""}

          </Row>
          {documentList[nameArray] && documentList[nameArray].map((document, index) => {
            return (
              <Row style={{ width: '100%', minWidth: '100%', justifyContent: 'space-between' }}>
                <React.Fragment key={index}>
                  <ListDetail
                    document={document}
                    idOperation={props.match.params.idOperation}
                    listDocuments={getFiles}
                    hasDelete={hasDelete}
                    columns={columns}
                    isClient={isClient}
                    nameArray={nameArray}
                    handleSelectDocument={handleSelectDocument}
                    selectedDocs={selectedDocs}
                    selectAllDocs={selectedAllDocsCheckBox}
                    permissions={permissions}
                    onHistoryClick={history ? ({ idDomain }) => showFilesExpired(idDomain) : false}
                    hiddenTrash={expired}
                    history={history}
                    expired={expired}
                  />
                </React.Fragment>
                <br />
              </Row>
            )
          })}
        </>
      </>
    );
  }

  const jsonToQueryString = (json) => {
    const keys = Object.keys(json).filter(key => json[key]);

    return keys
      .map((key, index) => {
        const sufix = index + 1 === keys.length
          ? ''
          : '&'

        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]) + sufix;
      }
      ).join('');
  }

  const handleSetFilterFromParams = () => {
    if (location.search) {
      const query = new URLSearchParams(location.search);

      if (query.get('search')) {
        filterFormik.current.setFieldValue('search', query.get('search'))
      }

      if (query.get('idOperation')) {
        filterFormik.current.setFieldValue('idOperation', Number(query.get('idOperation')))
      }

    }
  }

  const handleDownloadSelectedFiles = () => {
    setLoading(true);
    fitinsur.setAuthToken(authContext.token);

    if (selectedDocs.length === 0 && !selectedAllDocsCheckBox) {
      mc.error("Por favor, selecione pelo menos um documento.")
      setLoading(false);
      return;
    }

    const allDocuments = [...documents.signedDocuments, ...documents.dealDocuments, ...documents.supportDocuments, ...documents.internalDocuments, ...documents.creditAnalysis];

    const files = selectedDocs.map(docId => {
      const document = allDocuments.find(doc => doc.idDocument === docId);
      return {
        lnkAccessPdf: document.url,
        idReport: document.idDocument,
        title: document.documentName
      };
    });

    let fileName = "";
    fitinsur.requestDownloadAllFiles(files, props.match.params.idOperation).then(response => {
      if (response.status !== 200) {
        setLoading(false);
        throw new Error();
      }

      return response.blob().then((data) => {
        return {
          data: data,
          fileNameHeader: response.headers.get('Content-Disposition'),
        };
      });
    }).then(({ data, fileNameHeader }) => {
      const url = window.URL.createObjectURL(data);
      const a = document.createElement('a');

      fileName = fileNameHeader.split('filename=')[1].split('.')[0].replace(/^"|"$/g, '');

      a.style.display = 'none';
      a.href = url;
      a.download = fileName || 'extracted-files.zip';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      setLoading(false);
    }).catch(err => {
      console.log('error', err)
      setLoading(false);
    });
  }

  const handleFilter = (filters = {}) => {
    let filterQueryString;

    if (filters.search) {
      filterQueryString = { search: filters.search };
    } else {
      filterQueryString = { search: '' };
    }

    getFiles(filterQueryString);

    // Fix bug search and idOperation in url
    //history.push(`${filterQueryString}`);
  }

  const handleSaveCCG = (values) => {
    const validationSchema = {};
    questionnaire.forEach(question => {
      if (question.behaviorObject?.isRequired) {
        validationSchema[question.key] = yup.string().required("Campo obrigatório")
      }
    })

    const validation = yup.object().shape(validationSchema);

    validation.validate(values, { abortEarly: false }).then(() => {
      useSaveQuestionnaireAnswerRequest(questionnaire);
      setModalCcgConfirmation({ ...modalCcgConfirmation, show: false });

      mc.success("Redirecionando para Formalização do CCG");
      history.push(`/credit-analysis/stamps-status/${operation.idOperation}`);
      // getFiles();
    }).catch((e) => {
      events.onValidationError(
        e,
        mc,
        formik,
        questionnaire,
        []
      )
    })

  };

  let filterFormik = null;

  const renderAccordionDocuments = () => {
    return (
      <Container width={'100%'}>
        <FormContainer
          onCheckChange={() => handleSelectFolders('signedDocuments')}
          isChecked={selectedFolds.includes('signedDocuments')}
          hasCheckbox
          hide={false}
          title={`DOCUMENTOS ASSINADOS (${signedDocuments})`}
          collapsedAtStart="true"
          noTitlePadding={true}
        >
          <Row>
            {renderDocuments('', 'signedDocuments', false, false, false, false)}
          </Row>
        </FormContainer>

        <FormContainer
          onCheckChange={() => handleSelectFolders('dealDocuments')}
          isChecked={selectedFolds.includes('dealDocuments')}
          hasCheckbox
          hide={false}
          title={`PROCESSO (${dealDocuments})`}
          collapsedAtStart="true"
          noTitlePadding={true}
        >
          <Row>
            {renderDocuments('PROCESSO', 'dealDocuments', false, false, true, false)}
          </Row>
        </FormContainer>

        <FormContainer
          onCheckChange={() => handleSelectFolders('supportDocuments')}
          isChecked={selectedFolds.includes('supportDocuments')}
          hasCheckbox
          hide={false}
          title={`SUPORTE (${supportDocuments})`}
          collapsedAtStart="true"
          noTitlePadding={true}
        >
          <Row>
            {renderDocuments('', 'supportDocuments', false, true, false, false)}
          </Row>
        </FormContainer>

        {authContext.login_response.ret_value.applicationPersonRoot === authContext.login_response.ret_value.idPersonRoot &&
          <FormContainer
            onCheckChange={() => handleSelectFolders('internalDocuments')}
            isChecked={selectedFolds.includes('internalDocuments')}
            hasCheckbox
            hide={false}
            title={`INTERNOS (${internalDocuments})`}
            collapsedAtStart="true"
            noTitlePadding={true}
          >
            <Row>
              {!isClient ? renderDocuments('', 'internalDocuments', false, true, false, false) : null}
            </Row>
          </FormContainer>
        }

        <FormContainer
          onCheckChange={() => handleSelectFolders('paymentDocuments')}
          isChecked={selectedFolds.includes('paymentDocuments')}
          hasCheckbox
          hide={false}
          title={`FATURAS (${paymentDocuments})`}
          collapsedAtStart="true"
          noTitlePadding={true}
        >
          <Row>
            {renderDocuments('', 'paymentDocuments', false, true, false, false)}
          </Row>
        </FormContainer>

        <FormContainer
          onCheckChange={() => handleSelectFolders('creditAnalysis')}
          isChecked={selectedFolds.includes('creditAnalysis')}
          hasCheckbox
          hide={false}
          title={`ANÁLISE DE CRÉDITO (${creditAnalysis})`}
          collapsedAtStart="true"
          noTitlePadding={true}
        >
          <Row>
            {renderDocuments('', 'creditAnalysis', false, true, false, false)}
          </Row>
        </FormContainer>
      </Container>
    )
  }

  const changeShowAttachments = state => setShowAttachments(state);

  const changeAttachments = state => setAttachments(state);

  const renderModalConfirmation = (values, errors, setFieldError, setFieldValue) => {
    return <ModalEditConfirmation
      show={modalCcgConfirmation.show}
      title={`VIGÊNCIA CCG`}
      messages={[
        () => <>
          <Text>Deseja alterar a data de vigência do CCG anexado?</Text>
          <FormSection
            setQuestionnaire={setQuestionnaire}
            sectionName="ATTACHMENT_CCG"
            values={values}
            setFieldValue={setFieldValue}
            errors={errors}
            setFieldError={setFieldError}
            questionnaire={questionnaire}
            ignoreModality
            permissions={permissions}
            idProduct={operation?.idProduct}
            disableAll={false}
            showWarning={false}
            onQuestionChange={(
              question,
              value,
              setFieldValue,
              questionnaireUpdated
            ) => {
              if (question.idQuestion == 1727 && value) {
                setQuestionnaire(() => questionnaireUpdated
                  .map(qst => {
                    if (qst.idQuestion === 2016) {
                      qst.behaviorObject.isRequired = true;
                      qst.behavior = JSON.stringify(qst.behaviorObject);
                    };

                    return qst;
                  }))
              }
            }}
          />
        </>
      ]}
      onConfirm={() => handleSaveCCG(values)}
    />
  }
  return (
    <Layout
      title={"DOCUMENTOS"}
      idOperation={operation?.idOperation}
    >
      <BrokingSummary
        history={history}
        idOperation={props.match?.params?.idOperation}
        idProduct={props.match?.params?.idProduct}
        permissions={permissions}
      />
      <Content>
        <ListHeader
          title="DOCUMENTOS"
          formikRef={ref => filterFormik = ref}
          ListHeader
          operationFilter={shouldRenderOperationFilter}
          changeShowAttachments={changeShowAttachments}
          showAttachmentsState={showAttachments}
          operationsList={operationsList}
          updateFilter={(filters) => {
            handleFilter(filters)
          }}
          handleDownloadSelectedFiles={handleDownloadSelectedFiles}
          selectedAllDocsCheckBox={selectedAllDocsCheckBox}
        />
        <ListContent>
          <Formik
            onSubmit={(values) => {
              handleFilter(values)
            }}
            initialValues={initialValues}
            innerRef={formik}
            enableReinitialization={true}
          >
            {({ values, setFieldValue, validationSchema, errors, setFieldError, ...formikProps }) =>
              <Form>
                {showAttachments && (
                  <>
                    <div style={{ marginBottom: '40px' }}>
                      <FolderSelect hasFolderSelect={renderScreen}>
                        <span style={{ color: Colors.GRAY[0] }} onClick={() => setRenderScreen('')}>ANEXOS  &#40;{attachemnts.length}&#41;</span>
                      </FolderSelect>
                    </div>
                    {permissions.DOCUMENT_GENERAL?.CREATE && <DragZoneUpload
                      multiple={true}
                      changeShowAttachments={changeShowAttachments}
                      showAttachmentsState={showAttachments}
                      /* s3upload */
                      options={fieldRenderOptions(documents['documentTypes'])}
                      documentTypeRequired={true}
                      documentType={values.documentType}
                      idOperation={props.match.params.idOperation}
                      isDraft={false}
                      changeAttachments={changeAttachments}
                      question={questionAttachment}
                      onSuccess={(upLoadedFiles) => {
                        const docCCG = upLoadedFiles.find(doc => doc?.documentType?.idAnswerOption == 7687);
                        if (docCCG) {
                          setModalCcgConfirmation({ ...modalCcgConfirmation, show: true });
                          setDocumentCcg(docCCG.documentId);
                          return;
                        }
                        updateIsLoadingStatus(true);
                        getFiles();
                      }}
                    />}
                  </>
                )}

                <Row style={{ justifyContent: 'flex-end', margin: '10px' }}>
                  {/* <HasPermission permission={canAuthPolicyPack}>
                    <Col md={3}>
                      <Button
                        id="btnSave"
                        type="button"
                        custom={[Colors.WHITE, Colors.TERTIARY]}
                        onClick={() => handleSignaturePolicyPack()}
                      >
                        AUTENTICAR APÓLICE
                      </Button>
                    </Col>
                  </HasPermission> */}
                  <Col md={4}>
                    <Form>
                      <RowSearch>
                        <FieldGrid
                          name="search"
                          placeholder="Pesquisar"
                          value={values.search}
                          component={InputField}
                          type="text"
                          onChange={(e) => {
                            setFieldValue('search', e)
                          }}
                          validation={false}
                          list={true}
                          onPressEnter={() => {
                            formikProps.submitForm()
                          }}
                        />
                      </RowSearch>
                    </Form>
                  </Col>
                </Row>

                {renderAccordionDocuments()}

                <DialogComponent title={dialog.title} size='1000px' show={dialog.visible} setDialog={setDialog} center>
                  <div style={{ margin: 30 }}>
                    {renderDocuments('VERSÕES ANTERIORES', 'dealDocuments', false, false, false, true)}
                    <ButtonContainer className='justify-content-end'>
                      <ButtonContent>
                        <Button
                          id="btnContinue"
                          type="button"
                          style={{ margin: '0 0 15px 15px' }}
                          onClick={() => setDialog(prev => ({ ...prev, visible: false }))}
                          third
                        >
                          FECHAR
                        </Button>
                      </ButtonContent>
                    </ButtonContainer>
                  </div>
                </DialogComponent>

                {renderModalConfirmation(values, errors, setFieldError, setFieldValue)}

              </Form>
            }
          </Formik>
          <ButtonContainer>
            <Button forth onClick={() => handleBack()}>&lt; Voltar</Button>
          </ButtonContainer>
        </ListContent>
      </Content>
    </Layout>
  )
}